module.exports = __webpack_public_path__ + "static/media/bg.c275d439.webp";